import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Box, Toolbar, useMediaQuery } from '@mui/material';
import AppBar from './componentes/navegacion/Appbar';
import Sidebar from './componentes/navegacion/Sidebar';
import NuevaNormativa from './vistas/Normativa/NuevaNormativa';
import EditarNormativa from './vistas/Normativa/EditarNormativa';
import GestorNormativa from './vistas/Normativa/GestorNormativa';
import GestorNormativaUsuario from './vistas/Normativa/Usuario/GestorNormativaUsuario';
import TipoDocumento from './vistas/TipoDocumento/GestorTipoDocumento';
import ClasificacionDocumento from './vistas/ClasificacionDocumento/GestorClasificacionDocumento';
import EstadoTramitacion from './vistas/EstadoTramitacion/GestorEstadoTramitacion';
import Clientes from './vistas/Clientes/GestorClientes';
import Correos from './vistas/Correos/GestorCorreos';
import OrganismoEmisor from './vistas/OrganismoEmisor/GestorOrganismoEmisor';
import Rubros from './vistas/Rubros/GestorRubros';
import EnlaceCongreso from './vistas/EnlaceCongreso/GestorEnlaceCongreso';
import Compromisos from './vistas/Compromiso/GestorCompromiso';
import CompromisosUsuario from './vistas/Compromiso/Usuario/GestorCompromisoUsuario';
import PerfilUsuario from './vistas/Usuarios/PerfilUsuario';
import Usuarios from './vistas/Usuarios/GestorUsuarios';
import Home from './vistas/Home';
import LoginForm from './vistas/Login';
import AuthRedirect from './componentes/security/AuthRedirect';
import ProtectedRoute from './componentes/security/ProtectedRoute';
import Logs from './vistas/Configuracion/Logs/GestorLogs';
import HorarioCliente from './vistas/Clientes/HorarioClientes'
import DetalleCompromiso from './vistas/Compromiso/DetalleCompromiso';
import DetalleCompromisoPublico from './vistas/Compromiso/DetalleCompromisoPublico';
import GestionOrganismos from './vistas/Clientes/GestionOrganismos';
import GestionRubros from './vistas/Clientes/GestionRubros';
import ConfigurarSemaforo from './vistas/Clientes/ConfigurarSemaforo';
import GestorModulos from './vistas/Clientes/GestorModulos';
import GestorObligacionesUsuario from './vistas/Obligaciones/Usuario/GestorObligacionesUsuario';
import DetalleObligaciones from './vistas/Obligaciones/DetalleObligaciones';
import DetalleObligacionesPublico from './vistas/Obligaciones/DetalleObligacionesPublico';
import GestorConfiguracionCorreo from './vistas/Correos/GestorConfiguracionCorreo';
import EnvioManualCorreo from './vistas/Correos/EnvioManualCorreo';
import IntegracionGRCNormativas from './vistas/Normativa/Usuario/IntegracionGRCNormativas';
import GestorPais from './vistas/Pais/GestorPais';
import BandejaNormativas from './vistas/Bandeja/BandejaNormativa';
import HorarioEnvioScraperPanel from './vistas/Bandeja/HorarioEnvioScraperPanel';
import DetalleNormativaPublico from './vistas/Bandeja/DetalleNormativaPublico';
import Newsletter from './vistas/Newsletter/Newsletter';
import GestorOrgnanizaciones from './vistas/Clientes/GestorOrganizaciones';
import GestorNormativaGuardadas from './vistas/Normativa/Usuario/GestorNormativaGuardadas';
import AnalizadorNorma from './vistas/Normativa/AnalizadorNorma';
import ConfiguracionCupoAnalizador from './vistas/Configuracion/ConfiguracionCupoAnalizador';
import DashboardImpacto from './vistas/Dashboard/DashboardImpacto';
// ── Suscriptor (login propio + bandeja) ──
//import SuscriptorLogin from './vistas/Suscriptor/SuscriptorLogin';
import BandejaSuscriptor from './vistas/Suscriptor/BandejaSuscriptor';
import MiSuscripcion from './vistas/Suscriptor/MiSuscripcion';
//import LandingPage from './vistas/LandingPage';
import { useUserStatusValidator } from './hooks/useUserStatusValidator';

function MainLayout() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(true);
  const isSmallScreen = useMediaQuery('(max-width:600px)');

  useUserStatusValidator();

  useEffect(() => {
    if (isSmallScreen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  }, [isSmallScreen]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        handleDrawerToggle={handleDrawerToggle}
        isOpen={isOpen}
        toggleDrawer={toggleDrawer}
      />
      <Sidebar
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        isOpen={isOpen && !isSmallScreen}
        isSmallScreen={isSmallScreen}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 1, sm: 2, md: 3 },
          width: {
            xs: '100%',
            sm: `calc(100% - ${(isOpen && !isSmallScreen) ? 240 : 0}px)`
          },
          ml: {
            xs: 0,
            sm: `${(isOpen && !isSmallScreen) ? 0 : 0}px`
          },
          transition: theme => theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        <Toolbar />
        <Routes>
          <Route path="/home" element={<Home />} />
          <Route element={<ProtectedRoute allowedRoles={["Administrador", "Usuario"]} />}>
            <Route path="/usuario/gestor-normativa" element={<GestorNormativaUsuario />} />
            <Route path="/perfil-usuario" element={<PerfilUsuario />} />
            <Route path="/usuario/compromisos" element={<CompromisosUsuario />} />
            <Route path="/usuario/compromisos/normativa/:idNormativa" element={<DetalleCompromiso />} />
            <Route path="/usuario/obligaciones" element={<GestorObligacionesUsuario />} />
            <Route path="/usuario/obligaciones/normativa/:idNormativa" element={<DetalleObligaciones />} />
            <Route path="/usuario/integracion-grc-normativas" element={<IntegracionGRCNormativas />} />
            <Route path="/usuario/normativas-guardadas" element={<GestorNormativaGuardadas />} />
            <Route path="/usuario/analizador-norma" element={<AnalizadorNorma />} />
            <Route path="/dashboard-impacto" element={<DashboardImpacto />} />
          </Route>

          {/* ── Ruta del suscriptor: si no hay sesión, va a /suscriptor/login ── */}
          <Route element={<ProtectedRoute allowedRoles={["Suscriptor", "Administrador"]} />}>
            <Route path="/suscriptor/bandeja" element={<BandejaSuscriptor />} />
            <Route path="/suscriptor/mi-suscripcion" element={<MiSuscripcion />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={["Administrador"]} />}>
            <Route path="/perfil-usuario" element={<PerfilUsuario />} />
            <Route path="/usuarios" element={<Usuarios />} />
            <Route path="/nueva-normativa" element={<NuevaNormativa />} />
            <Route path="/gestor-normativa" element={<GestorNormativa />} />
            <Route path="/editar-normativa/:id" element={<EditarNormativa />} />
            <Route path="/compromisos" element={<Compromisos />} />
            <Route path='/tipo-documento' element={<TipoDocumento/>}/>
            <Route path='/enlace-congreso' element={<EnlaceCongreso/>}/>
            <Route path='/clasificacion-documento' element={<ClasificacionDocumento/>}/>
            <Route path='/estado-tramitacion' element={<EstadoTramitacion/>}/>
            <Route path='/cliente/gestor-clientes' element={<Clientes/>}/>
            <Route path='/cliente/gestor-organismos' element={<GestionOrganismos/>}/>
            <Route path='/cliente/gestor-rubros' element={<GestionRubros/>}/>
            <Route path='/cliente/configurar-semaforo' element={<ConfigurarSemaforo/>}/>
            <Route path='/cliente/gestor-modulos' element={<GestorModulos/>}/>
            <Route path='/cliente/correos' element={<Correos/>}/>
            <Route path='/organismo-emisor' element={<OrganismoEmisor/>}/>
            <Route path='/rubros' element={<Rubros/>}/>
            <Route path='/logs' element={<Logs/>}/>
            <Route path='/cliente/horario-clientes' element={<HorarioCliente/>}/>
            <Route path="/usuario/compromisos/normativa/:idNormativa" element={<DetalleCompromiso />} />
            <Route path='/envio-correo-normativa' element={<EnvioManualCorreo/>}/>
            <Route path='cliente/configuracion-correo' element={<GestorConfiguracionCorreo/>}/>
            <Route path='/paises' element={<GestorPais/>}/>
            <Route path='/bandeja-normativas' element={<BandejaNormativas/>}/>
            <Route path='/newsletter' element={<Newsletter/>}/>
            <Route path='/horario-envio-scraper' element={<HorarioEnvioScraperPanel/>}/>
            <Route path='/gestor-organizaciones' element={<GestorOrgnanizaciones/>}/>
            <Route path='/cliente/cupo-analizador' element={<ConfiguracionCupoAnalizador/>}/>
          </Route>
        </Routes>
      </Box>
    </Box>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        {/* <Route path="/" element={<LandingPage />} /> */}
        <Route path="/login" element={<AuthRedirect><LoginForm /></AuthRedirect>} />

        <Route path="/compromisos/normativa/:idNormativa" element={<DetalleCompromisoPublico />} />
        <Route path="/obligaciones/normativa/:idNormativa" element={<DetalleObligacionesPublico />} />
        <Route path="/bandeja/normativa/:id" element={<DetalleNormativaPublico />} />
        <Route path="/*" element={<AuthCheck><MainLayout /></AuthCheck>} />
      </Routes>
    </Router>
  );
}

const AuthCheck = ({ children }) => {
  const token = localStorage.getItem("token");

  if (!token) {
    window.location.href = '/login';
    return null;
  }

  return children;
};

export default App;
